import { buildSalesFilterGroups } from './salesFiltersConfig';

const UTM_FILTERS = [
  { id: 'utm_sources', label: 'Source', column: 'utm_source' },
  { id: 'utm_mediums', label: 'Medium', column: 'utm_medium' },
  { id: 'utm_campaigns', label: 'Campaign', column: 'utm_campaign' },
];

const toOptions = (values = []) =>
  values.map((value) => ({ value: String(value), label: String(value) }));

export const buildSalesBySourceFilterGroups = ({
  venueOwnerships = [],
  eventOptions = [],
  tagOptions = [],
  utmFilterOptions = {},
} = {}) => {
  const groups = buildSalesFilterGroups(venueOwnerships, eventOptions, tagOptions);

  UTM_FILTERS.forEach(({ id, label, column }) => {
    const options = utmFilterOptions[column] || [];
    if (options.length === 0) return;

    groups.push({
      id,
      label,
      filters: [
        {
          id,
          label,
          type: 'checkbox',
          options: toOptions(options),
        },
      ],
    });
  });

  return groups;
};
